const MAX_GIFT_CARDS_VALUE = process.env.NEXT_PUBLIC_MAX_GIFT_CARDS;
export const MAX_GIFT_CARDS = typeof MAX_GIFT_CARDS_VALUE === 'number' ? MAX_GIFT_CARDS_VALUE : 10;
export const MAX_SENDER_AMOUNT = process.env.NEXT_PUBLIC_MAX_SENDER_AMOUNT ?? 1000;
export const MAX_RECIPIENT_AMOUNT = process.env.NEXT_PUBLIC_MAX_RECIPIENT_AMOUNT ?? 500;

export const MAX_SENDER_GIFT_CARDS_KEY = 'MAX_SENDER_GIFT_CARDS';
export const MAX_RECIPIENT_GIFT_CARDS_KEY = 'MAX_RECIPIENT_GIFT_CARDS';
export const MAX_SENDER_AMOUNT_KEY = 'MAX_SENDER_AMOUNT';
export const MAX_RECIPIENT_AMOUNT_KEY = 'MAX_RECIPIENT_AMOUNT';


// Logged-in
export const USER_ACCOUNT_PURCHASER_LIMIT_AMOUNT_OF_CARDS_KEY = 'USER_ACCOUNT_PURCHASER_LIMIT_AMOUNT_OF_CARDS';
export const USER_ACCOUNT_PURCHASER_LIMIT_DOLLAR_VALUE_KEY = 'USER_ACCOUNT_PURCHASER_LIMIT_DOLLAR_VALUE';

// Logged-out
export const PURCHASER_LIMIT_AMOUNT_OF_CARDS_KEY = 'PURCHASER_LIMIT_AMOUNT_OF_CARDS';
export const PURCHASER_LIMIT_DOLLAR_VALUE_KEY = 'PURCHASER_LIMIT_DOLLAR_VALUE';

// Common
export const RECIPIENT_LIMIT_AMOUNT_OF_CARDS_KEY = 'RECIPIENT_LIMIT_AMOUNT_OF_CARDS';
export const RECIPIENT_LIMIT_DOLLAR_VALUE_KEY = 'RECIPIENT_LIMIT_DOLLAR_VALUE';

export const LOGGED_IN_USER_LIMIT_CONFIG_KEYS= [
    USER_ACCOUNT_PURCHASER_LIMIT_AMOUNT_OF_CARDS_KEY,
    USER_ACCOUNT_PURCHASER_LIMIT_DOLLAR_VALUE_KEY,
    RECIPIENT_LIMIT_AMOUNT_OF_CARDS_KEY,
    RECIPIENT_LIMIT_DOLLAR_VALUE_KEY
];

export const LOGGED_OUT_USER_LIMIT_CONFIG_KEYS= [
    PURCHASER_LIMIT_AMOUNT_OF_CARDS_KEY,
    PURCHASER_LIMIT_DOLLAR_VALUE_KEY,
    RECIPIENT_LIMIT_AMOUNT_OF_CARDS_KEY,
    RECIPIENT_LIMIT_DOLLAR_VALUE_KEY
];